export const DOWNLOAD_TRANSCRIPT_DATA = 'DOWNLOAD_TRANSCRIPT_DATA';
export const DOWNLOAD_TRANSCRIPT_DATA_RECEIVED = 'DOWNLOAD_TRANSCRIPT_DATA_RECEIVED';
